'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var BACKSPACE = 8;
var LEFT_ARROW = 37;
var RIGHT_ARROW = 39;
var CodeInput = function (props) {
    var _a = React.useState(0), activeInput = _a[0], setActiveInput = _a[1];
    var _b = React.useState(Array(props.codeLength).fill('')), otp = _b[0], setOtp = _b[1];
    /**
     * current input cell value
     * @param value
     * @return join cell value as string
     */
    var changeCodeAtFocus = function (value) {
        var newOtp = __spreadArrays(otp);
        newOtp[activeInput] = value;
        setOtp(newOtp);
        props.onInputChange && props.onInputChange(newOtp.join(''));
    };
    /**
     * focus input in the range of 0 to code length
     * Math.min ensure focus within the upperbound
     * Math.max ensure focus within the lowerbound
     * @param input target index
     */
    var focusInput = function (input) {
        var activeInput = Math.max(Math.min(props.codeLength - 1, input), 0);
        setActiveInput(activeInput);
    };
    var focusPreInput = function () {
        var preInput = activeInput - 1;
        focusInput(preInput);
    };
    var focusNextInput = function () {
        var nextInput = activeInput + 1;
        focusInput(nextInput);
    };
    /**
     * support three type of key events backspace, left, right
     * @param e
     */
    var onKeydown = function (e) {
        switch (e.keyCode) {
            case BACKSPACE:
                e.preventDefault();
                changeCodeAtFocus('');
                focusPreInput();
                break;
            case LEFT_ARROW:
                e.preventDefault();
                focusPreInput();
                break;
            case RIGHT_ARROW:
                e.preventDefault();
                focusNextInput();
                break;
            default:
                break;
        }
    };
    var handleFocus = function (e, index) {
        e.preventDefault();
        focusInput(index);
    };
    /**
     * target input will get value of length two
     * substring to get single target input
     */
    var handleInput = function (e) {
        e.preventDefault();
        var value = e.target.value;
        var targetValue = value.length > 1 ? value.charAt(value.length - 1) : value;
        focusNextInput();
        changeCodeAtFocus(targetValue);
    };
    return (React__default.createElement("div", { className: "code-wrapper" }, new Array(props.codeLength).fill(null).map(function (_, index) {
        return (React__default.createElement("input", { onFocus: function ($e) { return handleFocus($e, index); }, onKeyDown: function ($e) { return onKeydown($e); }, disabled: props.disabled, type: "text", className: 'code' + (activeInput === index ? ' focus' : ' '), key: index, value: otp[index], onChange: function ($e) { return handleInput($e); }, autoFocus: index === 0 }));
    })));
};

exports.default = CodeInput;
